import React from 'react';
import cx from 'classnames';

import { useGatekeepingCounterFiltered } from 'modules/gatekeeping/service';
import { GatekeepingProvider } from 'modules/gatekeeping/provider';

import { useDispatchingCounterFiltered } from 'modules/dispatching/service';
import { DispatchingProvider } from 'modules/dispatching/provider';

import { useDriverDayCounterFiltered } from 'modules/job-review/service';
import { JobReviewProvider } from 'modules/job-review/provider';

import FleetMenuItem from './FleetMenuItem';

import { ReactComponent as ArrowIcon } from 'assets/icons/chevron-right.svg';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getSpecificClientConfig, constants } from 'redux/modules/client-config/selectors';

const FleetMenu = ({ section, className, rootRoute, collapsed, onCollapseClick, intl }) => {
  const dispatchingSection = useSelector((state) =>
    getSpecificClientConfig(state, constants.DISPATCHING_SECTION)
  );

  const showText = !collapsed;
  const t = intl.messages.modules.FleetMenu;
  return (
    <div className={className} data-testid="fleetMenu">
      <ul className="menu-list">
        <li>
          <button
            type="button"
            className={cx('collapseButton', {
              collapsed: collapsed,
            })}
            onClick={onCollapseClick}
            data-testid="collapseButton"
          >
            <span>
              <ArrowIcon />
            </span>
          </button>
        </li>
        <li>
          <FleetMenuItem
            route="/gatekeeping"
            name={t.gatekeeping}
            showText={showText}
            rootRoute={rootRoute}
            mountWithProvider={section !== 'gatekeeping'}
            counterHook={useGatekeepingCounterFiltered}
            provider={GatekeepingProvider}
          />
          {dispatchingSection && (
            <FleetMenuItem
              route="/dispatching"
              name={t.dispatching}
              showText={showText}
              rootRoute={rootRoute}
              mountWithProvider={section !== 'dispatching'}
              counterHook={useDispatchingCounterFiltered}
              provider={DispatchingProvider}
            />
          )}
          <FleetMenuItem
            route="/driver-review"
            name={t.driver_review}
            showText={showText}
            rootRoute={rootRoute}
            mountWithProvider={section !== 'driver-review'}
            counterHook={useDriverDayCounterFiltered}
            provider={JobReviewProvider}
          />
        </li>
      </ul>
    </div>
  );
};

export default injectIntl(FleetMenu);
